import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Trans } from 'react-i18next';
import { connect } from 'react-redux';
import { animateToScreen as animateToScreenAction } from '../../redux/ui/actions';
import { reset } from '../../redux/cardReader/actions';
import TextColumnContent from '../../molecules/TextColumnContent';
import BackButtonContainer from '../../molecules/BackButtonContainer';
import ImagePreloader from '../../molecules/ImagePreloader';
import { H2, Ingress } from '../../components/Typography';
import Fade from '../../components/Fade';
import IconButton from '../../components/IconButton';
import Title from '../../components/Title';

import {
  TINY_BREAKPOINT_IN_PX,
  MOBILE_BREAKPOINT_IN_PX,
  TABLET_BREAKPOINT_IN_PX,
} from '../../constants';

const ViewTitle = styled(H2)`
  @media screen and (max-width: ${TABLET_BREAKPOINT_IN_PX}px) {
    margin-bottom: 20px;
  }
`;

const Texts = styled.div`
  margin-bottom: 34px;

  @media screen and (max-width: ${TABLET_BREAKPOINT_IN_PX}px) {
    margin-bottom: 22px;
  }

  @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
    margin-bottom: 12px;
  }
`;

const IconButtons = styled.div`
  padding-top: 20px;
  padding-bottom: 25px;
  margin-bottom: 25px;

  & > a {
    margin-bottom: 20px;
  }

  @media screen and (max-width: ${TABLET_BREAKPOINT_IN_PX}px) {
    padding-top: 20px;
    padding-right: 30px;
    padding-bottom: 15px;
    margin-bottom: 0;
  }

  @media screen and (max-width: ${MOBILE_BREAKPOINT_IN_PX}px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-top: 20px;
    padding-right: 30px;
    min-height: 251px;
    box-sizing: border-box;
    position: relative;
  }

  @media screen and (max-width: ${TINY_BREAKPOINT_IN_PX}px) {
    padding-right: 0px;
    min-height: 0px;
    padding-bottom: 0px;
  }
`;

class HomeTexts extends PureComponent {
  componentDidMount() {
    this.props.resetCardReader();
  }

  render() {
    const { animateToScreen, t } = this.props;
    return (
      <>
        <BackButtonContainer
          home={t('Generic.breadcrumbHome')}
          homeLink={t('Generic.breadcrumbHomeLink')}
          secondaryHome={t('Generic.breadcrumbSecondaryHome')}
          secondaryHomeLink={t('Generic.breadcrumbSecondaryHomeLink')}
          text={t('Flows.home')}
        />
        <TextColumnContent
          paddingTop={40}
          isBackButtonVisible={false}
          isHomeScreen
          fullScreen
        >
          <Fade>
            <Texts>
              <Title>
                <ViewTitle>
                  <Trans i18nKey="Home.title" />
                </ViewTitle>
              </Title>
              <Ingress>
                <Trans i18nKey="Home.description" />
              </Ingress>
            </Texts>
            <IconButtons>
              <IconButton
                text={t('Flows.valueTicket')}
                onClick={() => animateToScreen('ValueTicketRegion')}
              />
              <IconButton
                text={t('Flows.seasonalTicket')}
                onClick={() => animateToScreen('SeasonalTicketRegion')}
              />
              <IconButton
                text={t('Flows.additionalZone')}
                onClick={() => animateToScreen('AdditionalZoneRegion')}
              />
            </IconButtons>
          </Fade>
          {/* Hack for preloading card reader images */}
          <ImagePreloader />
        </TextColumnContent>
      </>
    );
  }
}

HomeTexts.propTypes = {
  animateToScreen: PropTypes.func.isRequired,
  resetCardReader: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  animateToScreen: (screenName) => dispatch(animateToScreenAction(screenName)),
  resetCardReader: () => dispatch(reset()),
});

// prettier-ignore
export default connect(null, mapDispatchToProps)(HomeTexts);
